function checkPaginationV(swiper) {
  if (!swiper) return;

  const slidesVisible = swiper.params.slidesPerView;

  const visibleSlides = Array.from(swiper.slides).filter(
    slide => slide.classList.contains('swiper-slide-duplicate') === false &&
      slide.style.display !== 'none'
  ).length;

  const paginationEl = swiper.pagination && swiper.pagination.el;
  const prevBtn = document.querySelector('.swiper-button-prev');
  const nextBtn = document.querySelector('.swiper-button-next');

  const shouldHide = visibleSlides <= slidesVisible || visibleSlides <= 1;

  if (paginationEl) {
    paginationEl.style.display = shouldHide ? 'none' : 'flex';
  }

  if (prevBtn) {
    prevBtn.style.display = shouldHide ? 'none' : 'flex';
  }

  if (nextBtn) {
    nextBtn.style.display = shouldHide ? 'none' : 'flex';
  }
}

function pauseAndResetAllVideos(swiper) {
  if (!swiper) return;

  swiper.slides.forEach(slide => {
    const iframe = slide.querySelector('iframe');
    if (!iframe) return;

    try {
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      iframe.contentWindow.postMessage(JSON.stringify({ method: 'setCurrentTime', value: 0 }), '*');
    } catch (e) { }
  });
}

let globalSwiperInstance = null;
let allSlidesData = [];

function createSlideElement(key) {
  const li = document.createElement('li');
  li.classList.add('swiper-slide');
  li.dataset.category = key.video_category;

  const divBox = document.createElement('div');
  divBox.classList.add('video-box');

  const wrapper = document.createElement('div');
  wrapper.classList.add('vimeo-wrapper');

  const iframe = document.createElement('iframe');
  iframe.src = `https://player.vimeo.com/video/${key.video_folder}?h=${key.video_url}&controls=1&autoplay=0`;
  iframe.title = key.video_title;
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

  wrapper.appendChild(iframe);
  divBox.appendChild(wrapper);

  const contentDiv = document.createElement('div');
  contentDiv.classList.add('content-box');

  const header = document.createElement('h2');
  header.innerHTML = key.video_header;
  contentDiv.appendChild(header);

  const badgeSpan = document.createElement('span');
  badgeSpan.classList.add('badge');
  badgeSpan.innerHTML = key.video_badge || key.video_category || 'Non-category';
  contentDiv.appendChild(badgeSpan);

  const text = document.createElement('p');
  text.innerHTML = key.video_text;
  contentDiv.appendChild(text);

  li.appendChild(divBox);
  li.appendChild(contentDiv);

  return li;
}

function rebuildSwiper(selectedCat) {
  const swiperWrapper = document.querySelector('.swiper-wrapper-videos');
  if (!swiperWrapper) return;

  if (globalSwiperInstance) {
    pauseAndResetAllVideos(globalSwiperInstance);
    globalSwiperInstance.destroy(true, true);
    globalSwiperInstance = null;
  }

  swiperWrapper.innerHTML = '';

  const filteredData = allSlidesData.filter(slideData => {
    return selectedCat === 'all' || slideData.video_category === selectedCat;
  });

  filteredData.forEach(key => {
    const slideElement = createSlideElement(key);
    swiperWrapper.appendChild(slideElement);
  });

  globalSwiperInstance = new Swiper('.swiper-video', {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    loop: filteredData.length > 1,

    navigation: {
      nextEl: '.section-videos .swiper-button-next',
      prevEl: '.section-videos .swiper-button-prev',
    },

    pagination: {
      el: '.section-videos .swiper-pagination',
      clickable: true,
    },

    on: {
      init(swiper) {
        checkPaginationV(swiper);
      },
      resize(swiper) {
        checkPaginationV(swiper);
      },
      slideChange(swiper) {
        pauseAndResetAllVideos(swiper);
      },
    },
  });

  return globalSwiperInstance;
}

function initCategoryUI() {
  const categoryBox = document.querySelector('.category');
  const changeBtn = document.querySelector('.change-category');
  const currentCategoryLabel = document.querySelector('.current-category');
  const categoryLinks = document.querySelectorAll('[data-change-category]');

  if (!categoryBox || !changeBtn) return;

  changeBtn.addEventListener('click', e => {
    e.preventDefault();
    categoryBox.classList.toggle('open');
    changeBtn.style.display = 'none';
    currentCategoryLabel.style.display = 'none';

    const currentCategory = currentCategoryLabel.textContent;

    categoryLinks.forEach(link => {
      link.classList.remove('active');
      if (link.textContent === currentCategory) {
        link.classList.add('active');
      }
    });
  });

  categoryLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      changeBtn.style.display = 'block';
      currentCategoryLabel.style.display = 'inline-block';

      const selectedCat = link.dataset.changeCategory;
      const selectedLabel = link.textContent;

      currentCategoryLabel.textContent = selectedLabel;
      categoryBox.classList.remove('open');

      rebuildSwiper(selectedCat);
    });
  });

  document.addEventListener('click', e => {
    if (!categoryBox.contains(e.target)) {
      categoryBox.classList.remove('open');
    }
  });
}

function videoDataRender() {
  const swiperWrapper = document.querySelector('.swiper-wrapper-videos');
  if (!swiperWrapper) return;

  fetch('./data/videos.json')
    .then(response => {
      if (!response.ok) throw new Error('Błąd w sieci.');
      return response.json();
    })
    .then(data => {
      allSlidesData = data.video;

      data.video.forEach(key => {
        const slideElement = createSlideElement(key);
        swiperWrapper.appendChild(slideElement);
      });

      globalSwiperInstance = new Swiper('.swiper-video', {
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        loop: true,

        navigation: {
          nextEl: '.section-videos .swiper-button-next',
          prevEl: '.section-videos .swiper-button-prev',
        },

        pagination: {
          el: '.section-videos .swiper-pagination',
          clickable: true,
        },

        on: {
          init(swiper) {
            checkPaginationV(swiper);
          },
          resize(swiper) {
            checkPaginationV(swiper);
          },
          slideChange(swiper) {
            pauseAndResetAllVideos(swiper);
          },
        },
      });

      initCategoryUI();
    })
    .catch(error => {
      console.error('Wystąpił problem:', error);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  videoDataRender();
});